import Blank from "@/layouts/blank.vue";
import VendorSubHireUploadList from "@/pages/admin/vendor-subhire-upload/VendorSubHireUploadList.vue";
import VendorSubHireUploadDetails from "@/pages/admin/vendor-subhire-upload/VendorSubHireUploadDetails.vue";
import VendorSubHireUploadMonitor from "@/pages/admin/vendor-subhire-upload/VendorSubHireUploadMonitor.vue";

const vendorSubHireUploadRoutes = [
  {
    path: "vendor-subhire-upload",
    name: "app-admin-vendor-subhire-upload",
    component: Blank,
    children: [
      {
        path: "/",
        redirect: "/app/admin/vendor-subhire-upload/list",
      },
      {
        path: "list",
        name: "app-admin-vendor-subhire-upload-list",
        component: VendorSubHireUploadList,
      },
      {
        path: "details/:id",
        name: "app-admin-vendor-subhire-upload-details",
        component: VendorSubHireUploadDetails,
      },
      {
        path: "monitor",
        name: "app-admin-vendor-subhire-upload-monitor",
        component: VendorSubHireUploadMonitor,
      },
    ],
  },
];

export default vendorSubHireUploadRoutes;
